// @ts-nocheck
import Lottie from 'lottie-react'
import React from 'react'

import * as defaultAnimationData from '../Assets/Lottie/loader.json'

interface LottieControlProps {
  animationData?: any
}

export default class LottieControl extends React.Component<LottieControlProps> {
  render() {
    const { animationData } = this.props;
    return (
      <div className="lottie-loader">
        <Lottie animationData={animationData || defaultAnimationData} />
      </div>
    )
  }
}
